/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExtractionMethod } from './ExtractionMethod.js';
import {
    ExtractionMethodFromJSON,
    ExtractionMethodFromJSONTyped,
    ExtractionMethodToJSON,
} from './ExtractionMethod.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface UpdateExtractorRequest
 */
export interface UpdateExtractorRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateExtractorRequest
     */
    label?: string;
    /**
     * 
     * @type {ExtractionMethod}
     * @memberof UpdateExtractorRequest
     */
    method?: ExtractionMethod;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof UpdateExtractorRequest
     */
    role?: ParticipantRole;
    /**
     * 
     * @type {number}
     * @memberof UpdateExtractorRequest
     */
    threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateExtractorRequest
     */
    options?: string;
}

/**
 * Check if a given object implements the UpdateExtractorRequest interface.
 */
export function instanceOfUpdateExtractorRequest(value: object): boolean {
    return true;
}

export function UpdateExtractorRequestFromJSON(json: any): UpdateExtractorRequest {
    return UpdateExtractorRequestFromJSONTyped(json, false);
}

export function UpdateExtractorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExtractorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'method': json['method'] == null ? undefined : ExtractionMethodFromJSON(json['method']),
        'role': json['role'] == null ? undefined : ParticipantRoleFromJSON(json['role']),
        'threshold': json['threshold'] == null ? undefined : json['threshold'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function UpdateExtractorRequestToJSON(value?: UpdateExtractorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'method': ExtractionMethodToJSON(value['method']),
        'role': ParticipantRoleToJSON(value['role']),
        'threshold': value['threshold'],
        'options': value['options'],
    };
}

